// extracted by mini-css-extract-plugin
module.exports = {"container":"RangePicker_container__1qOI_","label":"RangePicker_label__2NgS6","star":"RangePicker_star__1KJRe"};